import { LT30 } from 'src/constants/loan'

export const avgSolarPanelInstallCost = 17000
export const avgSellingCostPercent = 0.07
export const lowFeePercent = 0.05
export const highFeePercent = 0.13

export const dreamHome = {
  downPaymentPercent: 0.2,
  loanTerm: LT30
}
export const rentalProperty = {
  minimumEquity: 25000,
  targetLTV: 0.7,
  downPaymentPercent: 0.3,
  loanTerm: LT30,
  interestRateAdjustment: 0.75
}

export const rentBuy = {
  downPaymentPercent: 0.3,
  loanTerm: LT30
}

export const studentDebt = {
  average: 38000
}
